import { type TranslationTree } from '@/i18n/types';

export const messages = {
  copyLink: 'Copiar link',
  copyCoupon: 'Copiar cupom',
  linkCopied: 'Link copiado',
  couponCopied: 'Cupom copiado',
  copyError: 'Não foi possível copiar',
  clicks: 'Cliques',
  signups: 'Cadastros',
  paying: 'Pagantes',
} satisfies TranslationTree;
